import * as React from "react";

function EditPen(props) {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.49913 4.44507L7.55493 3.50087L1.3355 9.7203V10.6645H2.2797L8.49913 4.44507ZM9.44333 3.50087L10.3875 2.55667L9.44333 1.61247L8.49913 2.55667L9.44333 3.50087ZM2.8326 12H0V9.16673L8.97123 0.195508C9.09645 0.0703245 9.26626 0 9.44333 0C9.62039 0 9.7902 0.0703245 9.91543 0.195508L11.8045 2.08457C11.9297 2.2098 12 2.37961 12 2.55667C12 2.73374 11.9297 2.90355 11.8045 3.02877L2.83326 12H2.8326Z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoEditPen = React.memo(EditPen);
export default MemoEditPen;
